module.exports = __webpack_public_path__ + "prod/1.42.2/img/second-picture.9fe0fee5.png";